import { Injectable } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { 
     DrawingAdditionalToursRequestDto,
     DrawingAdditionalToursResponseDto,
     DrawingBasketDto,
     DrawingEuroGroupRequestdto,
     DrawingEuroGroupResponseDto,
     DrawingEuroPlayoffBaskets,
     DrawingEuroPlayoffRequest,
     DrawingEuroPlayoffResultDto,
     DrawingEuroResultDto,
     DrawingEuroStageWinnersDto,
     DrawingWCFinalDto,
     DrawingWCFinalResponseDto
     } from "app/models";
import { DrawingEuroDto } from "app/models/dtos/drawing-euro.dto";
import { DrawClubWCPlayoffRequest, DrawingClubWCGroupBasketsDto, DrawingclubWCGroupStageResultDto, DrawingCWCGroupStageRequest, DrawingEuroSuperCupDto, DrawingFixtureDto, DrawingNationalCupRequest, DrawingNationalSuperCupPairDto, DrawingNationalSuperCupRequest, DrawingWCFinalDataDto, DrawingWCFinalRequestDto, DrawingWCPlayoffResponseDto, GroupDto, NationalCupCountriesDto, TeamShortDto } from "app/models/dtos";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";
import { DrawingWCNationalTeamBaskets } from "app/models/dtos/drawing-national-team-baskets";
import { HttpParams } from "@angular/common/http";
import { DrawWcPlayoffRequest } from "app/models/dtos/draw-wc-playoff.request.dto";

@Injectable()
export class DrawingsService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getEuroRatings(): Observable<DrawingEuroDto> {
        return this.httpService.get<DrawingEuroDto>(this.apiUrl + 'drawing/euro/coeffs', null);
    }

    drawPlayoff(stage: number, md1: number, md2: number, lchBasket: DrawingBasketDto, leBasket: DrawingBasketDto, lkBasket: DrawingBasketDto): Observable<DrawingEuroPlayoffResultDto> {
        let request = new DrawingEuroPlayoffRequest();
        request.championsLeagueBasket = lchBasket;
        request.euroLeagueBasket = leBasket;
        request.conferenceLeagueBasket = lkBasket;
        request.matchDay1 = md1;
        request.matchDay2 = md2;
        request.stage = stage;

        return this.httpService.post<DrawingEuroPlayoffResultDto>(this.apiUrl + 'drawing/playoff', null, request, true);
    }

    drawGroup(mds: number[], lchBaskets: number[][], leBaskets: number[][], lkBaskets: number[][]): Observable<DrawingEuroGroupResponseDto> {
        let request = new DrawingEuroGroupRequestdto();
        request.matchDays = mds;
        request.championsLeagueBaskets = lchBaskets;
        request.euroLeagueBaskets = leBaskets;
        request.conferenceLeagueBaskets = lkBaskets;
        

        return this.httpService.post<DrawingEuroGroupResponseDto>(this.apiUrl + 'drawing/group', null, request, true);
    }

    drawFinal(md1: number, lchBasket: DrawingBasketDto, leBasket: DrawingBasketDto, lkBasket: DrawingBasketDto): Observable<DrawingEuroPlayoffResultDto> {
        let request = new DrawingEuroPlayoffRequest();
        request.stage = CONSTANTS.euroCupStages.final;
        request.championsLeagueBasket = lchBasket;
        request.euroLeagueBasket = leBasket;
        request.conferenceLeagueBasket = lkBasket;
        request.matchDay1 = md1;
        request.matchDay2 = request.matchDay1;

        return this.httpService.post<DrawingEuroPlayoffResultDto>(this.apiUrl + 'drawing/final', null, request, true);
    }

    getDrawingEuroResults(): Observable<DrawingEuroResultDto[]> {
        return this.httpService.get<DrawingEuroResultDto[]>(this.apiUrl + 'drawing/euro/results', null);
    }

    getEuroStageWinners(): Observable<DrawingEuroStageWinnersDto[]> {
        return this.httpService.get<DrawingEuroStageWinnersDto[]>(this.apiUrl + 'drawing/euro/winners', null);
    }

    getEuroStageLoosers(): Observable<DrawingEuroStageWinnersDto[]> {
        return this.httpService.get<DrawingEuroStageWinnersDto[]>(this.apiUrl + 'drawing/euro/loosers', null);
    }

    getPrePlayoffBaskets(): Observable<DrawingEuroPlayoffBaskets> {
        return this.httpService.get<DrawingEuroPlayoffBaskets>(this.apiUrl + 'drawing/euro/pre-playoff', null);
    }

    addAdditionalToursFor16Teams(request: DrawingAdditionalToursRequestDto): Observable<DrawingAdditionalToursResponseDto[]> {
        return this.httpService.post<DrawingAdditionalToursResponseDto[]>(this.apiUrl + 'drawing/additional-tours-16', null, request, true);
    }

    addAdditionalToursFor12Teams(request: DrawingAdditionalToursRequestDto): Observable<DrawingAdditionalToursResponseDto[]> {
        return this.httpService.post<DrawingAdditionalToursResponseDto[]>(this.apiUrl + 'drawing/additional-tours-12', null, request, true);
    }

    getEuroSuperCupPair(): Observable<DrawingEuroSuperCupDto> {
        return this.httpService.get<DrawingEuroSuperCupDto>(this.apiUrl + 'drawing/euro/super-cup', null);
    }

    getNationalSuperCupPairs(): Observable<DrawingNationalSuperCupPairDto[]> {
        return this.httpService.get<DrawingNationalSuperCupPairDto[]>(this.apiUrl + 'drawing/national/super-cup', null);
    }

    saveEuroSuperCupFixture(team1: TeamShortDto, team2: TeamShortDto, md: number): Observable<DrawingFixtureDto> {
        let request = {
            team1: team1,
            team2: team2,
            matchDay: md
        }
        return this.httpService.post<DrawingFixtureDto>(this.apiUrl + 'drawing/euro/super-cup', null, request, true);
    }

    saveNationalSuperCupPairs(pairs: DrawingNationalSuperCupPairDto[], matchDay: number) : Observable<DrawingFixtureDto[]> {

        let request =  new DrawingNationalSuperCupRequest();
        request.matchDay = matchDay;
        request.pairs = pairs;
        
        return this.httpService.post<DrawingFixtureDto[]>(this.apiUrl + 'drawing/national/super-cup', null, request, true);
    }

    getNationalCupPairs(stage: number) :Observable<NationalCupCountriesDto> {
        return this.httpService.get<NationalCupCountriesDto>(this.apiUrl + 'drawing/national/cup/' + stage + '/pairs', null, true);
    }

    drawNationalCup(md: number, stage: number): Observable<NationalCupCountriesDto> {
        let request = new DrawingNationalCupRequest();
        request.stage = stage;
        request.matchDay = md;

        return this.httpService.post<NationalCupCountriesDto>(this.apiUrl + 'drawing/national/cup', null, request, true);
    }

    getWCFinalData() :Observable<DrawingWCFinalDataDto> {
        return this.httpService.get<DrawingWCFinalDataDto>(this.apiUrl + 'drawing/wc/data', null, true);
    }

    getWCFinalBaskets(request: DrawingWCFinalDataDto) :Observable<DrawingWCFinalDto> {
        return this.httpService.post<DrawingWCFinalDto>(this.apiUrl + 'drawing/wc/baskets', null, request, true);
    }

    getWCQualificationBaskets() :Observable<DrawingWCFinalDto> {
        return this.httpService.get<DrawingWCFinalDto>(this.apiUrl + 'drawing/wc/qualification-baskets', null, true);
    }

    drawFCFinal(nat: DrawingWCNationalTeamBaskets, u21: DrawingWCNationalTeamBaskets, mds: number[]) :Observable<DrawingWCFinalResponseDto> {
        let request = new DrawingWCFinalRequestDto();
        request.nat = nat;
        request.u21 = u21;
        request.mds = mds;

        return this.httpService.post<DrawingWCFinalResponseDto>(this.apiUrl + 'drawing/wc/final', null, request, true);
    }

    drawWCQualification(mds: number[]) :Observable<DrawingWCFinalResponseDto> {
        let request = new DrawingWCFinalRequestDto();
        request.mds = mds;

        return this.httpService.post<DrawingWCFinalResponseDto>(this.apiUrl + 'drawing/wc/qualification-groups', null, request, true);
    }

    getWCPrePlayoffData(stage: number) :Observable<DrawingWCPlayoffResponseDto> {
        let params = new HttpParams();
        params = params.append("stage", stage.toString());

        return this.httpService.get<DrawingWCPlayoffResponseDto>(this.apiUrl + 'drawing/wc/pre-playoff', params, true);
    }

    drawWcPlayoff(md: number, stage: number): Observable<boolean> {
        let request = new DrawWcPlayoffRequest();
        request.md = md;
        request.stage = stage;

        return this.httpService.post<boolean>(this.apiUrl + 'drawing/wc/playoff', null, request, true);
    }

    getClubWCGroupBaskets(): Observable<DrawingClubWCGroupBasketsDto> {
        return this.httpService.get<DrawingClubWCGroupBasketsDto>(this.apiUrl + 'drawing/club-wc/group-baskets', null, true);
    }

    drawClubWCGroupStage(baskets: DrawingClubWCGroupBasketsDto, mds: number[]) :Observable<DrawingclubWCGroupStageResultDto> {
        var request = new DrawingCWCGroupStageRequest();
        request.baskets = baskets;
        request.mds = mds;
        
        return this.httpService.post<DrawingclubWCGroupStageResultDto>(this.apiUrl + 'drawing/club-wc/group-stage', null, request, true);
    }

    getClubWCPrePlayoffData(stage: number) :Observable<DrawingFixtureDto[]> {
        let params = new HttpParams();
        params = params.append("stage", stage.toString());

        return this.httpService.get<DrawingFixtureDto[]>(this.apiUrl + 'drawing/club-wc/pre-playoff', params, true);
    }

    drawClubWcPlayoff(md: number, stage: number, fixtures: DrawingFixtureDto[]): Observable<boolean> {
        let request = new DrawClubWCPlayoffRequest();
        request.md = md;
        request.stage = stage;
        request.fixtures = fixtures;

        return this.httpService.post<boolean>(this.apiUrl + 'drawing/club-wc/playoff', null, request, true);
    }

    createCarousel(): Observable<boolean> {
        return this.httpService.post<boolean>(this.apiUrl + 'drawing/carousel/create', null, null, true);
    }
}